import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { investorApi } from "../../api/api";
import { GoRows } from "react-icons/go";

const InvestPayment = () => {
  const [rows, setRows] = React.useState([]);
  const [statusFilter, setStatusFilter] = React.useState("All");
  const navigate = useNavigate();

  const handleAction = (action, row) => {
    if (action === "edit") {
      navigate(`/property/editProperty?propertyId=${row.id}`, {
        state: {
          investmentId: row.id,
        },
      });
    } else if (action === "update") {
      navigate(`/property/marketPrice?propertyId=${row.id}`, {
        state: {
          investmentId: row.id,
        },
      });
    }
  };

  const handleFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };



  useEffect(() => {
    const fetchPaymentData = async () => {
      // const id= '3';
      const response = await investorApi.getPaymentData();
      setRows(response.data);
    };
    fetchPaymentData();
  }, []);
  // console.log(rows);
  // Filter the data based on statusFilter
  const filteredData = rows
    .filter((item) => statusFilter === "All" || item.Status === statusFilter) // Apply filtering logic
    .map((item, index) => ({
      id: item.investmentId || index, // Ensure unique 'id' for each row
      InvestorId: item.investorId,
      PropertyName: item.propertyName,
      InvestorName: item.InvestorName,
      noofunit: item.noofunit,
      amountinInvested: item.amountinInvested,
      status: item.Status,
    }));
  //  console.log(filteredData);

  const getStatusColor = (Status) => {
    switch (Status) {
      case "Initiated":
        return "red";
      case "Rejected":
        return "blue";
      case "Payment Pending":
        return "orange";
      case "Completed":
        return "green";
      default:
        return "#000000";
    }
  };

  const capitalizeName = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const columns = [
    { field: "investorId", headerName: "ID", width: 70 },
    { field: "InvestorName", headerName: "Investor Name", width: 150 },
    {
      field: "PropertyName",
      headerName: "Property Name",
      width: 300,
      renderCell: (params) => <span>{capitalizeName(params.value)}</span>,
    },
    { field: "noofunit", headerName: "No of Unit", width: 250 },
    { field: "amountinInvested", headerName: "Amount Invested", width: 200 },
    {
      field: "status",
      headerName: "Status",
      width: 220,
      renderCell: (params) => {
        const statusColor = getStatusColor(params.value);
        return (
          <div
            style={{
              color: statusColor,
              fontWeight: "bold",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(`/investment/statusPage/${params.value}`, {
                state: {
                  investmentId: params.row.id, // ✅ Fix: Use params.row
                  propertyName: params.row.PropertyName, // ✅ Fix: Use params.row
                  investorName: params.row.InvestorName, // ✅ Fix: Use params.row
                  amountInvested: params.row.amountinInvested, // ✅ Fix: Use correct field name
                },
              })
            }
          >
            {params.value}
          </div>
        );
      },
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 4,
        px: 2,
      }}
    >
      <div className="dashboard section_space_bottom">
        <Box
          sx={{ flexGrow: 1 }}
          style={{ border: "2px solid lightgray", borderRadius: "5px" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <h1
                style={{
                  margin: "20px 20px",
                  color: "#13216E",
                  fontWeight: "600",
                  fontSize: "20px",
                }}
              >
                Payment
              </h1>
            </Grid>
            <Grid
              item
              xs={4}
              style={{ padding: "20px 20px 0 0", textAlign: "end" }}
            >
              <FormControl variant="outlined" sx={{ minWidth: 120 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={statusFilter}
                  onChange={handleFilterChange}
                  label="Status"
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Initiated">Initiated</MenuItem>
                  <MenuItem value="Payment Pending">Inprogress</MenuItem>
                  <MenuItem value="Completed">Completed</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <DataGrid
          rows={filteredData} // Use filtered data for display
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 25]}
          disableSelectionOnClick
          autoHeight={false}
        />
      </div>
    </Box>
  );
};

export default InvestPayment;
